export default "__VITE_ASSET__D$CI5213__"